import { render, staticRenderFns } from "./cms-foot.vue?vue&type=template&id=87d07a14&scoped=true"
import script from "./cms-foot.vue?vue&type=script&lang=js"
export * from "./cms-foot.vue?vue&type=script&lang=js"
import style0 from "./cms-foot.vue?vue&type=style&index=0&id=87d07a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d07a14",
  null
  
)

export default component.exports